angular.module('tgaAdmin')
  .controller('HubArchiveController', [
    '$scope', '$rootScope', '$state', '$window', '$filter', '$timeout', '$uibModal',
    'hubService', 'modalService', 'userService', 'divisionService', 'flashService',
    'ngIntroService',
    function (
      $scope, $rootScope, $state, $window, $filter, $timeout, $uibModal,
      hubService, modalService, userService, divisionService, flashService,
      ngIntroService,
    ) {
      $scope.showBack = $state.current.data.back;

      $scope.data = {
        alerts: [],
        divisions: [],
        isAdmin: userService.checkUserType(['admin', 'super_admin', 'sales_admin', 'support_admin']),
        isEditor: userService.checkUserType(['editor', 'creator_admin']),
        isSuperAdmin: userService.checkUserType(['super_admin']),
      };

      $scope.viewmodel = {
        hubs: [],
      };

      $scope.initialize = function () {
        $scope.loading = true;

        divisionService.getDivisions().then((divisions) => {
          $scope.data.divisions = divisions;
        });
      };

      $scope.actions = {
        loadHubs(tableState) {
          $scope.loading = true;

          const params = tableState ? {
            paginate: true,
            page: Math.floor(tableState.pagination.start / tableState.pagination.number) + 1,
            limit: tableState.pagination.number,
            sort: tableState.sort.predicate,
            order: tableState.sort.reverse ? 'desc' : 'asc',
            is_archived: 1,
          } : {};

          if (tableState?.search?.predicateObject) {
            Object.keys(tableState.search.predicateObject).forEach((key) => {
              // Check for divisions first and set values to a divisions array
              if (key === 'divisions') {
                params['divisions[]'] = Object.keys(tableState.search.predicateObject.divisions).map(
                  (divisionKey) => tableState.search.predicateObject.divisions[divisionKey].value,
                );
              } else {
                params[key] = tableState.search.predicateObject[key];
              }
            });
          }

          hubService.getArchivedHubs(params).then((response) => {
            $scope.viewmodel.hubs = response.items || response;
            $scope.loading = false;
            if (tableState) {
              tableState.pagination.numberOfPages = Math.ceil(response.total / tableState.pagination.number);
              tableState.pagination.totalItemCount = response.total;
            }
          });
        },

        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },

        archiveHub(hub, is_archived) {
          hub.processing = true;

          // If is_archived is set, then we are unarchiving, else we archive.
          const data = {
            hub_id: hub.hub_id,
            is_archived,
          };

          hubService.archiveHub(data).then(
            () => {
              flashService.set('<span class="fa fa-check"></span> Game unarchived successfully.', 'success');
              $state.go('v1.hubs');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              hub.processing = false;
            },
          );
        },
      };

      $scope.$on('$destroy', () => {
        ngIntroService.clear();
      });

      $scope.initialize();
    },
  ]);
